import { render, staticRenderFns } from "./FunnelTab.vue?vue&type=template&id=55ae9e13"
import script from "./FunnelTab.vue?vue&type=script&lang=js"
export * from "./FunnelTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports